// extracted by mini-css-extract-plugin
module.exports = {"nav":"menu-component_nav__12Cvj","mobileMenu":"menu-component_mobileMenu__gZOqg","sideBar":"menu-component_sideBar__2t5RB","sideBarContent":"menu-component_sideBarContent__1n3Dp"};